let id = 0;

export function createid(): string {
  // return Date.now().toString(36) + Math.random().toString(36).slice(2);
  return `${++id}`;
}
